import { render, staticRenderFns } from "./AddStatusToFile.vue?vue&type=template&id=4ae4bdc1&"
import script from "./AddStatusToFile.vue?vue&type=script&lang=js&"
export * from "./AddStatusToFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports